import { useRef, useEffect } from "react";

function useDeleteKey(handle: VoidFunction): void {
  const handleRef = useRef(handle);
  handleRef.current = handle;

  useEffect(() => {
    const keyPressHandler = (event: KeyboardEvent) => {
      if (event.code === 'Delete' || event.code === 'Backspace') {
        const handle = handleRef.current;
        handle();
      }
    }

    document.addEventListener('keydown', keyPressHandler);
    return () => {
      document.removeEventListener('keydown', keyPressHandler);
    }
  }, []);
}

export default useDeleteKey;